var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRssPetals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 32900",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248 153.831"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 379",
    d: "M247.468 122.176c-.212-.352-21.483-35.141-48.132-26.674-1.161.369-17.047 6.343-27.564 10.307a51.223 51.223 0 01.053 36.429c10.284 3.888 25.645 9.674 27.508 10.261 26.677 8.4 47.9-25.578 48.113-25.921a4.385 4.385 0 00.553-2.225 4.3 4.3 0 00-.531-2.177z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 380",
    d: "M213.109 38.529a4.362 4.362 0 00-1.182-1.962 4.283 4.283 0 00-1.914-1.163c-.4-.1-40.04-9.66-52.9 15.174-.562 1.083-7.58 16.565-12.214 26.806a51.348 51.348 0 0125.744 25.723c10.022-4.524 25.034-11.321 26.771-12.226 24.807-12.928 15.79-51.958 15.695-52.352z",
    fill: "#f18700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 381",
    d: "M105.807 76.227a51.218 51.218 0 0136.4.032c3.886-10.284 9.7-25.723 10.291-27.593 8.4-26.677-25.576-47.9-25.921-48.113A4.4 4.4 0 00124.352 0a4.287 4.287 0 00-2.174.532c-.352.212-35.144 21.483-26.674 48.134.362 1.161 6.339 17.042 10.303 27.561z",
    fill: "#fdc300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 382",
    d: "M103.102 77.347c-4.524-10.019-11.318-25.028-12.224-26.764-12.924-24.8-51.958-15.784-52.349-15.69a4.382 4.382 0 00-1.965 1.179 4.31 4.31 0 00-1.163 1.914c-.1.4-9.658 40.04 15.174 52.9 1.08.56 16.482 7.541 26.723 12.175a51.35 51.35 0 0125.804-25.714z",
    fill: "#95c11f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 383",
    d: "M72.777 124.088a51.024 51.024 0 013.391-18.323c-10.284-3.888-25.638-9.672-27.5-10.259-26.677-8.4-47.9 25.578-48.114 25.924a4.371 4.371 0 00-.553 2.223 4.3 4.3 0 00.532 2.177c.212.352 21.48 35.141 48.132 26.674 1.156-.366 16.92-6.3 27.439-10.261a51 51 0 01-3.327-18.155z",
    fill: "#009640"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 384",
    d: "M72.777 124.088v-.157H.016a4.147 4.147 0 00.516 1.9c.212.352 21.48 35.141 48.132 26.674 1.156-.366 16.92-6.3 27.439-10.261a51 51 0 01-3.326-18.156z",
    fill: "#006b2d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 385",
    d: "M87.884 87.783l-51.5-51.5a4.153 4.153 0 00-.979 1.709c-.1.4-9.658 40.04 15.174 52.9 1.08.56 16.482 7.541 26.723 12.175a51.237 51.237 0 0110.582-15.284z",
    fill: "#688816"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 386",
    d: "M105.807 76.227a51.05 51.05 0 0118.155-3.326h.111V.016a4.138 4.138 0 00-1.9.516c-.352.212-35.144 21.483-26.674 48.134.367 1.161 6.344 17.042 10.308 27.561z",
    fill: "#ad8900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 387",
    d: "M160.187 87.921l51.538-51.541a4.165 4.165 0 00-1.707-.977c-.4-.1-40.04-9.66-52.9 15.174-.562 1.083-7.58 16.565-12.214 26.806a51.343 51.343 0 0115.283 10.538z",
    fill: "#a66000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 388",
    d: "M175.147 124.076h72.837a4.148 4.148 0 00-.516-1.9c-.212-.352-21.483-35.141-48.132-26.674-1.161.369-17.047 6.343-27.564 10.307a51.042 51.042 0 013.375 18.267z",
    fill: "#9c1006"
  })));
}

export default __webpack_public_path__ + "8bdd1424d47260c3c64dceeac9960e97.svg";
export { SvgRssPetals as ReactComponent };